/*
This Sequence class is responsible for UI and rendering concerns, depending on a biojs/Sequence stored as
_sequence.

 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {noop} from '@benchling/js-utils';
import Backbone, {Collection, ModelSetOptions} from 'backbone';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import Trim from 'analyses/alignment/Trim';
import {Analyses, Analysis, AnalysisAttributes} from 'analyses/Analyses';
import PrimerWizardTabState from 'analyses/primers/PrimerWizardTabState';
import * as analytics from 'analytics/Analytics';
import {ArchiveRecord} from 'archive/ArchiveConstants';
import asm from 'assembly/Asm';
import {assert} from 'Asserts';
import {Permissions} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import * as benchlingUtil from 'BenchlingUtil';
import * as BioJS from 'BioJS';
import {Annotation as BioJSAnnotation, AnnotationAttributes, AnnotationCollection} from 'biojs/Annotation';
import {CodonTranslationTable, NucleotideType} from 'biojs/BioConstants';
import {FragmentResult as FragmentResultModel} from 'biojs/FragmentResult';
import {Part, PartAttributes} from 'biojs/Part';
import {PrimerPairAttributes} from 'biojs/PrimerPair';
import {
  Casing,
  CreateFromIndicesOptions,
  Model as BioJSSequence,
  ModifiedNucleotides,
  SaveXHR,
  SequenceAnalysisSummary,
  SequenceAttributes as BioJSSequenceAttributes,
  TranslationGroup,
} from 'biojs/Sequence';
import {Collection as BioJSSequencePrimers, SequencePrimerAttributes} from 'biojs/SequencePrimer';
import {
  Collection as BioJSTranslations,
  Translation as BioJSTranslation,
  TranslationAttributes,
} from 'biojs/Translation';
import * as biojsUtil from 'biojs/Util';
import {MOLBIO_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {EventConstants} from 'constants/EventConstants';
import {NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants, {SequenceSubtype} from 'constants/ModelTypeConstants';
import {Strand, StrandOfDoubleStranded} from 'constants/MolbioConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {CopyPreferences, ModifiedNucleotideAttributes, SequenceType} from 'constants/SequenceConstants';
import {BulkSetModsParams, PositionalRule, SeqOperation, SeqOpOptions} from 'constants/SequenceOpConstants';
import {User} from 'constants/UserConstants';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import FileState from 'filestate/FileState';
import FileStates, {SequenceFileState} from 'FileStates';
import BaseFolderItem, {BaseFolderItemAttributes} from 'folder-items/BaseFolderItem';
import {SchemaTag, Tag as TagType} from 'folder-items/FileConstants';
import {getInsufficientPermissionsToEditMessage} from 'folder-items/FileUtil';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import {doQuerySafe, readQuerySafe, writeQuery} from 'graphql-client/ApolloWrappers';
import {initBackboneToGraphQLSync} from 'graphql-client/backbone-graphql-sync/initBackboneToGraphQLSync';
import {SyncedModelName} from 'graphql-client/backbone-graphql-sync/SyncedModels';
import AppDispatcher from 'lib/Dispatcher';
import {IsContainedInComplexPolymerData} from 'modbio/complex-polymers/ComplexPolymerConstants';
import {isFullUTFlexibilityEnabled} from 'modbio/util';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import Annotation from 'molbio/annotations/backbone/Annotation';
import Annotations from 'molbio/annotations/backbone/Annotations';
import CodonOptimizationTabState from 'molbio/codon-optimization/CodonOptimizationTabState';
import {
  CopyNucleotideSequenceMode,
  getCopyDataForSequenceAndSelection,
  getPrimersForCopy,
} from 'molbio/CopyUtil';
import * as SequenceDAO from 'molbio/dao/SequenceDAO';
import Cutsite from 'molbio/enzymes/backbone/CutSite';
import CutSites from 'molbio/enzymes/backbone/CutSites';
import Enzymes, {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import {EnzymePreferences} from 'molbio/enzymes/EnzymeConstants';
import * as EnzymeUtil from 'molbio/enzymes/EnzymeUtil';
import CreateLinkableBioentityModal, {
  ConfirmCreateLinkableBioentityPayload,
  CreateLinkableBioentityModalProps,
} from 'molbio/linkable-bioentity/CreateLinkableBioentityModal';
import CopySelectionModal, {CopySelectionModalProps} from 'molbio/maps/CopySelectionModal';
import DNA from 'molbio/maps/selectables/DNA';
import {Selection} from 'molbio/maps/selectables/Selection';
import {SequenceMapPreferences} from 'molbio/maps/SequenceMapConstants';
import SequenceMapUtil from 'molbio/maps/SequenceMapUtil';
import {editNucleotideIndices} from 'molbio/monomers/NucleotidesUIReduxActions';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import SequencePrimers from 'molbio/primers/backbone/SequencePrimers';
import * as sequtil from 'molbio/SeqUtil';
import {
  TranscriptionIndicesQuery,
  TranscriptionIndicesQuery_sequence_SequenceNode_transcriptionMatches_TranscriptionMatchNode as TranscriptionMatch,
  TranscriptionIndicesQueryVariables,
} from 'molbio/transcriptions/__generated/TranscriptionIndicesQuery';
import {
  TRANSCRIPTION_INDICES_QUERY,
  TranscriptionMatches,
} from 'molbio/transcriptions/TranscriptionConstants';
import ORF from 'molbio/translations/backbone/ORF';
import ORFs from 'molbio/translations/backbone/ORFs';
import Translation from 'molbio/translations/backbone/Translation';
import Translations from 'molbio/translations/backbone/Translations';
import {updateModelsAfterTranslationChange} from 'molbio/translations/TranslationUtil';
import {ServerNotePart} from 'notebook/util/NoteUtilConstants';
import notifications, {Response} from 'notifications';
import * as popup from 'Popup';
import preferences from 'Preferences';
import {getStore} from 'redux-stores/Store';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import {BioentityLinkFieldWithTagSchema} from 'schemas/fields/SchemaFieldConstants';
import {SchemaValidationState} from 'schemas/SchemaValidationConstants';
import legacyRunModal from 'ui-library/legacyRunModal';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import {clipboard} from 'util/BenchlingClipboard';
import * as net from 'util/Net';
import pick from 'util/pick';
import {GenericEvent, Optional} from 'util/Types';
import * as VersionHistoryUtil from 'util/VersionHistoryUtil';

import CopyOptionsModalTemplate from './CopyOptionsModalTemplate';
import GoldenGateCutSites from './GoldenGateCutSites';
import PrimerAssemblyMismatches from './PrimerAssemblyMismatches';
import SequenceAttributeCollection from './SequenceAttributeCollection';
import {SequenceSearchResult} from './SequenceSearchView';
import Tag from './Tag';
import Tags from './Tags';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface DoSeqOpReturnPromise extends JQueryPromise<any> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  client: JQueryPromise<any>;
}

interface LockingTab {
  tabId: string;
  tabName: string;
}

export type CreateFromSelectionOptions = Omit<CreateFromIndicesOptions, 'parentVersionId'>;

export interface CleanMetadataResponse {
  all_valid: boolean;
  invalid_primers: Array<SequencePrimerAttributes>;
}

interface VersionSummary {
  id: number;
  name: string;
  created_at: string;
  parentId: number | null;
  user?: User;
}

interface VersionPart {
  id: number;
  position: number;
  sequence_id: string | null;
  reverse: boolean;
  complement: boolean;
}

interface VersionAttributes extends VersionSummary {
  active: boolean;
  type: 'versions';
  sequence_primers: Array<SequencePrimerAttributes>;

  // version.sequence_metadata
  bases: string;
  circular: boolean;
  startIndex: number;
  finalized: boolean;
  annotations: Array<AnnotationAttributes>;
  translations: Array<TranslationAttributes>;
  translation_groups: Array<TranslationGroup>;
  parts: Array<VersionPart>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fragment_results: any;
  primer_pairs: Array<PrimerPairAttributes>;
  modified_nucleotides: ModifiedNucleotides;
}

interface Version {
  get<K extends keyof VersionAttributes>(key: K): VersionAttributes[K];
}

class Version extends Backbone.Model {
  override defaults(): Partial<VersionAttributes> {
    return {
      type: 'versions',
    };
  }

  active(): VersionAttributes['active'] {
    return this.get('active');
  }

  cleanMetadata(): JQueryPromise<CleanMetadataResponse> {
    return $.ajax({
      url: `${this.url()}/validate`,
      type: 'GET',
      dataType: 'json',
    }).done(
      // eslint-disable-next-line no-restricted-syntax
      _.bind(function (this: Version, res: CleanMetadataResponse): void {
        let sequencePrimers = this.get('sequence_primers');
        for (const sp of Array.from(res.invalid_primers)) {
          // eslint-disable-next-line no-restricted-syntax
          sequencePrimers = _.filter(sequencePrimers, (p) => p.id !== sp.id);
        }
        this.set('sequence_primers', sequencePrimers);
      }, this)
    );
  }
}

class Versions extends SequenceAttributeCollection<Version, VersionAttributes> {
  static override initClass(): void {
    this.prototype.model = Version;
    this.prototype.attributeName = 'versions';
  }

  getLastId(): number | null {
    if (this.size() !== 0) {
      return _.max(this.pluck('id'));
    } else {
      return null;
    }
  }
}

Versions.initClass();

type TabId = string;

interface AllowEditOptions {
  ignoreVersion?: boolean;
  ignoreLocked?: boolean;
  tabId?: TabId;
}

export interface TranslationDict {
  id: number;
  start: number;
  end: number;
  strand: Strand;
  aminoAcidLength: number;
  editable: boolean;
  fromSubPart: boolean;
}

export interface TranslationGroupDict {
  id: number;
  translations: Array<TranslationDict>;
  aminoAcidLength: number;
  name: string;
}

export interface SequenceAttributes extends BaseFolderItemAttributes {
  _sequence: BioJSSequence;
  activeVersionId: number;
  analyses: Analyses<Analysis, AnalysisAttributes>;
  annotations: Annotations;
  currentVersion: boolean;
  cutsites: CutSites;
  dna: DNA;
  editURL: string;
  enzymes: Enzymes;
  fileState: FileState;
  goldenGateCutSites: GoldenGateCutSites;
  id: string;
  isContainedInComplexPolymerData: IsContainedInComplexPolymerData | null;
  lockingTabQueue: Array<LockingTab>;
  orfs: ORFs;
  permissions: Permissions;
  primerAssemblyMismatches: PrimerAssemblyMismatches;
  projectFolderId: BioJSSequenceAttributes['projectFolderId'];
  selection: Selection;
  sequencePrimers: SequencePrimers;
  // tags: Tags; BaseFolderItem declares tags as a POJO array instead of Backbone Collection
  tagSchema: TagSchema | null;
  transcriptionMatches: Array<TranscriptionMatch>;
  translations: Translations;
  writable: boolean;
  versions: Versions;
  trim?: Trim;
}

type HoistedMethod<A extends keyof BioJSSequence> = ReturnType<BioJSSequence[A]>;

interface Sequence {
  get<K extends keyof SequenceAttributes>(key: K): SequenceAttributes[K];
  // TODO listenTo always returns the model; Backbone types are wrong
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenTo(object: any, events: string, callback: Function): Sequence;
  set(obj: Partial<SequenceAttributes>, options?: ModelSetOptions): Sequence;
  set<K extends keyof SequenceAttributes>(
    attributeName: K,
    value: SequenceAttributes[K],
    options?: ModelSetOptions
  ): Sequence;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(attributeName: string, value: any, options?: ModelSetOptions): never;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trigger(eventName: string, ...args: Array<any>): Sequence;
  fileState(): SequenceFileState;
}

class Sequence extends BaseFolderItem {
  _annotations?: AnnotationCollection;
  _translations!: BioJSTranslations;
  _primers!: BioJSSequencePrimers;
  oldRangeStart?: number;
  oldRangeEnd?: number;

  // Assigned in initialize
  batchResetPrimer!: Function;

  override defaults(): Partial<SequenceAttributes> {
    return {
      // fileState: null,
      currentVersion: true,
      orfs: new ORFs(),
    };
  }

  // BaseFolderItem overrides
  override name(): BioJSSequenceAttributes['name'] {
    return this._sequence().get('name');
  }

  override displayLabel(): BioJSSequenceAttributes['displayLabel'] {
    return this._sequence().get('displayLabel');
  }

  override folder(): HoistedMethod<'folder'> {
    return this._sequence().folder();
  }

  nucleotideType(): BioJSSequenceAttributes['nucleotideType'] {
    return this._sequence().get('nucleotideType');
  }

  override projectFolderId(): BioJSSequenceAttributes['projectFolderId'] {
    return this._sequence().get('projectFolderId');
  }

  override setFolder(folder: NumberIDFolder): void {
    this._sequence().set({folder});
    this.trigger('change');
  }

  override clearProjectFolder(): BioJSSequence {
    return this._sequence().set({projectFolderId: null});
  }

  override setProjectFolder(projectFolder: StringIDFolder | NumberIDFolder): BioJSSequence {
    return this._sequence().set({projectFolderId: projectFolder.api_identifier});
  }

  override initialNote(): BioJSSequenceAttributes['note'] {
    return this.get('_sequence').get('note');
  }

  override permissions(): BioJSSequenceAttributes['permissions'] {
    return this._sequence().get('permissions');
  }

  override setPermissions(permissions: Permissions): void {
    // TODO(BNCH-954): Ensure this._sequence('writable') and this.writable() are always in sync.
    this._sequence().set({permissions, writable: permissions.writable});
    // Include writable for legacy before moving to the permissions dict.
    this.set({writable: permissions.writable});
    this.trigger('change');
  }

  override setNameAndDisplayLabel(name: string, displayLabel: string): void {
    this._sequence().set({name, displayLabel});
  }

  override writable(): SequenceAttributes['writable'] {
    return this.get('writable');
  }

  _allowAnyEdits(options: AllowEditOptions = {}): boolean {
    if (options == null) {
      options = {};
    }
    return (
      (options.ignoreVersion || this.get('currentVersion')) &&
      (options.ignoreLocked || !this.get('_sequence').get('locked')) &&
      !this.get('_sequence').get('unrecoverable') &&
      (this.lockingTab() == null || options.tabId === this.lockingTab().tabId)
    );
  }

  override allowEdits(options?: AllowEditOptions): boolean {
    return this.writable() && this._allowAnyEdits(options);
  }

  isContainedInComplexPolymerData(): SequenceAttributes['isContainedInComplexPolymerData'] {
    return this.get('isContainedInComplexPolymerData');
  }

  allowResidueEdits(options?: AllowEditOptions): boolean {
    assert(this.permissions() != null, 'Expected permissions to be defined on sequence');
    return (
      (this.permissions().polymerResiduesEditable ?? false) &&
      this._allowAnyEdits(options) &&
      !this.isContainedInComplexPolymerData()?.isContained
    );
  }

  allowFeatureEdits(options?: AllowEditOptions): boolean {
    assert(this.permissions() != null, 'Expected permissions to be defined on sequence');
    return Boolean(this.permissions().polymerFeaturesEditable) && this._allowAnyEdits(options);
  }

  override modifiedAt(): BioJSSequenceAttributes['modified_at'] {
    return this.get('_sequence').get('modified_at');
  }

  override createdAt(): HoistedMethod<'createdAt'> {
    return this.get('_sequence').createdAt();
  }

  // Required by MetadataTab
  override tags(): Array<SchemaTag> {
    return (this.get('tags') as unknown as Tags).toJSON();
  }

  override setTags(tags: Array<TagType>): void {
    // @ts-expect-error Backbone types are wrong; reset can accept attribute hashes as well as models
    this.get('tags').reset(tags);
    this.trigger('change');
  }

  override tagSchema(): BioJSSequenceAttributes['tagSchema'] {
    return this._sequence().get('tagSchema');
  }

  override setTagSchema(tagSchema: TagSchema): void {
    this._sequence().set({tagSchema});
    this.trigger('change');
  }

  override authors(): BioJSSequenceAttributes['authors'] {
    return this._sequence().get('authors');
  }

  override setAuthors(authors: Array<User>): BioJSSequence {
    return this._sequence().set({authors});
  }

  override archiveRecord(): BioJSSequenceAttributes['archiveRecord'] {
    return this._sequence().get('archiveRecord');
  }

  override setArchiveRecord(archiveRecord: ArchiveRecord | null): void {
    this._sequence().set({archiveRecord});
    this.trigger('change');
  }

  override setSchemaValidationState(schemaValidationState: Optional<SchemaValidationState>): void {
    this._sequence().set({schemaValidationState});
    this.trigger('change');
  }

  override initialBioentityAliasInfos(): BioJSSequenceAttributes['bioentityAliasInfos'] {
    return this._sequence().get('bioentityAliasInfos');
  }

  // TODO T3917: refactor notifications and setBanner to use same text
  override setBanner(): void {
    const lockingTab = this.lockingTab();
    if (this.allowResidueEdits()) {
      this.setBannerText(null);
    } else if (this._sequence().get('unrecoverable')) {
      this.setBannerText('Editing is disabled and your changes have not been saved.');
    } else if (this._sequence().get('locked')) {
      this.setBannerText('Editing is disabled because sequence edits have been locked.');
    } else if (lockingTab != null) {
      this.setBannerText(`Editing disabled because the sequence \
has been locked by ${lockingTab.tabName}.`);
    } else if (!this.get('currentVersion')) {
      const maybeTranscriptionMatches = this.get('transcriptionMatches');
      this.setBannerText(
        `Editing disabled on previous versions. ${
          maybeTranscriptionMatches && maybeTranscriptionMatches.length > 0
            ? 'Transcription links will not be displayed.'
            : ''
        }`
      );
    } else if (this.isContainedInComplexPolymerData()?.isContained) {
      this.setBannerText(
        `Editing bases is disabled because sequence ${this.isContainedInComplexPolymerData()!.errorMessage!}`
      );
    } else if (this.allowFeatureEdits() || this.writable()) {
      this.setBannerText('Editing bases is disabled due to insufficient permissions.');
    } else if (this.isArchived()) {
      this.setBannerText('Editing disabled on archived sequence.');
    } else {
      this.setBannerText(getInsufficientPermissionsToEditMessage(this.permissions(), 'sequence'));
    }
  }

  override schemaValidationState(): BioJSSequenceAttributes['schemaValidationState'] {
    return this._sequence().get('schemaValidationState');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  duplicate(options: {name?: string; version?: any; folderId?: string; skipPrompt?: boolean} = {}): void {
    const DuplicateModal = require('molbio/components/DuplicateModal').default; // Avoid circular import
    const FileBrowserActions = require('file-browser/FileBrowserActions').default;

    const modal = new DuplicateModal({
      name: options.name != null ? options.name : this.name(),
      version: options.version != null ? options.version : 'latest',
      initialFolderId: options.folderId,
      analyses: this.analyses()
        .filter((analysis) => !analysis.isNew())
        .map((analysis) => ({dbId: analysis.id, name: analysis.get('name')})),
      sequenceID: this.id,
      cloneSuccess(res: {id: string}): void {
        notifications.success('Sequence successfully duplicated.');
        FileBrowserActions.openFile(res.id);
      },
    });
    if (options.skipPrompt) {
      modal.render();
      modal.clone();
      modal.remove();
    } else {
      new popup.Confirm({title: 'Copy Sequence to Folder', msg: modal.render().el, view: modal})
        .choice('Duplicate', 'btn-af-success', modal.clone, undefined, {
          component: 'DuplicateSequenceModal',
          element: 'submitButton',
        })
        .choice('Cancel', 'btn-af-default')
        .show();
    }
  }

  isReallyBig(): boolean {
    return this.length() > 400000;
  }

  bases(): BioJSSequenceAttributes['bases'] {
    return this.get('_sequence').bases();
  }

  type(): BioJSSequenceAttributes['type'] {
    return this._sequence().get('type');
  }

  subtype(): SequenceSubtype {
    if (this._sequence().get('type') !== SequenceType.OLIGO) {
      return this.nucleotideType() === biojsUtil.NucleotideType.RNA
        ? ModelTypeConstants.RNA_SEQUENCE
        : ModelTypeConstants.SEQUENCE;
    }

    return this.nucleotideType() === biojsUtil.NucleotideType.RNA
      ? ModelTypeConstants.RNA_OLIGO
      : ModelTypeConstants.DNA_OLIGO;
  }

  _sequence(): BioJSSequence {
    return this.get('_sequence');
  }

  analyses(): SequenceAttributes['analyses'] {
    return this.get('analyses');
  }

  annotations(): SequenceAttributes['annotations'] {
    return this.get('annotations');
  }

  translationGroups(): BioJSSequenceAttributes['translationGroups'] {
    return this._sequence().translationGroups();
  }

  translations(): SequenceAttributes['translations'] {
    return this.get('translations');
  }

  sequencePrimers(): SequenceAttributes['sequencePrimers'] {
    return this.get('sequencePrimers');
  }

  fragmentResults(): HoistedMethod<'fragmentResults'> {
    return this.get('_sequence').fragmentResults();
  }

  orfs(): SequenceAttributes['orfs'] {
    return this.get('orfs');
  }

  primerAssemblyMismatches(): SequenceAttributes['primerAssemblyMismatches'] {
    return this.get('primerAssemblyMismatches');
  }

  goldenGateCutSites(): SequenceAttributes['goldenGateCutSites'] {
    return this.get('goldenGateCutSites');
  }

  /**
   * Whether or not the user is allowed to insert at sequence region at the given position.
   *
   * Note: This affects isSelectionEditable() and isSelectionDeletable(), which are used elsewhere to block
   * edits and show a relevant error message. It's recommended to check SequenceMapUtil.paste() and
   * PolymerMapTabView.handleKeydown()
   */
  canInsertAt(position: number): boolean {
    if (
      this.get('_sequence').get('type') !== SequenceType.OLIGO &&
      this.hasNullPhosphate() &&
      position === this.length()
    ) {
      return false;
    }
    if (position === this.length()) {
      position = 0;
    }

    for (const part of this.parts().models) {
      if (sequtil.baseInExclusiveRange(position, part.start(), part.end())) {
        return false;
      }
    }

    if (!BenchlingConfig.MOLBIO_ENABLE_EDITING_BIOINTELLIGENT_LINKS) {
      return true;
    }

    const maybeTranscriptionMatches = this.get('transcriptionMatches');

    if (maybeTranscriptionMatches == null) {
      return true;
    }

    for (const transcription of maybeTranscriptionMatches) {
      if (sequtil.baseInExclusiveRange(position, transcription.start, transcription.end)) {
        return false;
      }
    }

    return true;
  }

  isRegionEditable(start: number, end: number): boolean {
    if (this.parts().getSequencePartsBetween(start, end).length > 0) {
      return false;
    }

    if (!BenchlingConfig.MOLBIO_ENABLE_EDITING_BIOINTELLIGENT_LINKS) {
      return true;
    }

    const maybeTranscriptionMatches = this.get('transcriptionMatches');

    if (maybeTranscriptionMatches == null) {
      return true;
    }
    for (const transcription of maybeTranscriptionMatches) {
      if (sequtil.isRangeOverlap(transcription.start, transcription.end, start, end)) {
        return false;
      }
    }
    return true;
  }

  getSequencePartsAt(position: number): HoistedMethod<'getSequencePartsAt'> {
    return this.get('_sequence').getSequencePartsAt(position);
  }

  partHasOverlaps(part: Part): HoistedMethod<'partHasOverlaps'> {
    return this.get('_sequence').partHasOverlaps(part);
  }

  hasNullPhosphate(): HoistedMethod<'hasNullPhosphate'> {
    return this.get('_sequence').hasNullPhosphate();
  }

  getSequencePartsAtSelectionStart(): Array<Part> {
    const selectionStart = this.selection().start();
    return this.getSequencePartsAt(selectionStart === this.length() ? 0 : selectionStart);
  }

  getSequencePartsInSelection(): Array<Part> {
    const start = this.selection().start() === this.length() ? 0 : this.selection().start();
    const end = this.selection().end();
    if (end == null) {
      return this.getSequencePartsAt(start);
    } else {
      return this.parts().getSequencePartsBetween(start, end);
    }
  }

  getTranscriptionsInSelection(): Array<TranscriptionMatch> {
    if (this.get('transcriptionMatches') == null) {
      return [];
    }
    const start = this.selection().start() === this.length() ? 0 : this.selection().start();
    const end = this.selection().end();
    if (end == null) {
      return this.get('transcriptionMatches').filter((t) => sequtil.baseInRange(start, t.start, t.end));
    } else {
      return this.getTranscriptionsBetween(start, end);
    }
  }

  getTranscriptionsBetween(start: number, end: number): Array<TranscriptionMatch> {
    if (this.get('transcriptionMatches') == null) {
      return [];
    }
    return this.get('transcriptionMatches').filter((t) => sequtil.isRangeOverlap(t.start, t.end, start, end));
  }

  parts(): BioJSSequenceAttributes['parts'] {
    return this.get('_sequence').get('parts');
  }

  modifiedNucleotides(): BioJSSequenceAttributes['modifiedNucleotides'] {
    return this.get('_sequence').get('modifiedNucleotides');
  }

  residueSlice(start: number, end: number, allowEmpty?: boolean): HoistedMethod<'residueSlice'> {
    return this.get('_sequence').residueSlice(start, end, allowEmpty);
  }

  locked(): HoistedMethod<'locked'> {
    return this._sequence().locked();
  }

  canUseFullUTFlexibility(): boolean {
    return this.isOligo() && isFullUTFlexibilityEnabled();
  }

  recalculateTranscriptionMatches(transcriptions: TranscriptionMatches): void {
    if (transcriptions.__typename === 'SequenceNode') {
      this.set('transcriptionMatches', transcriptions.transcriptionMatches);
    }
  }

  async cacheTranscriptionMatches(): Promise<void> {
    // Recalculate indices of transcription matches when dependent features are updated.
    // Transcriptions don't have an underlying model, and cannot store location information. Instead the,
    // transcriptions on the sequence map are calculated based on the DNA's schema tags, bases, and linked
    // parts. After relevant updates, this function caches the new indices of transcription on the DNA
    // Sequence.
    const sequenceId = this.id;
    // Alignment views create temporary sequence models that are visualized but not persisted and do not have
    // standard sequence IDs. To avoid breaking graphql serialization, sequences with these IDs are filtered
    // out before querying transcriptions.
    if (sequenceId == null || !sequenceId.startsWith('seq_')) {
      return;
    }
    // Lower-level components that render transcriptions rely on the results of this query being present in the Apollo cache.
    // Because these components can sometimes render before the query completes, causing an error when no transcriptions field is found,
    // we have to prime the cache with an empty list of transcriptions if there is not yet any data.
    if (readQuerySafe({query: TRANSCRIPTION_INDICES_QUERY}, {variables: {sequenceId}}) == null) {
      writeQuery<TranscriptionIndicesQuery, TranscriptionIndicesQueryVariables>(
        {query: TRANSCRIPTION_INDICES_QUERY},
        {
          sequence: {
            __typename: 'SequenceNode',
            id: sequenceId,
            transcriptionMatches: [],
          },
        },
        {sequenceId}
      );
    }

    const transcriptionData = await doQuerySafe<
      TranscriptionIndicesQuery,
      TranscriptionIndicesQueryVariables
    >({query: TRANSCRIPTION_INDICES_QUERY}, {variables: {sequenceId}, fetchPolicy: 'network-only'});
    this.recalculateTranscriptionMatches(transcriptionData.sequence);
  }

  registerTranscriptionListeners(): void {
    const updateTranscriptionsCallback = (): void => {
      this.cacheTranscriptionMatches();
    };
    this.listenTo(this.get('tags'), 'reset', updateTranscriptionsCallback);
    this.listenTo(this._sequence(), 'change:bases change:parts', updateTranscriptionsCallback);
  }

  _translationToDict(translation: Translation): TranslationDict {
    return {
      id: translation.id,
      start: translation.start(),
      end: translation.end(),
      strand: translation.strand(),
      aminoAcidLength: translation.aminoAcidLength(this),
      editable: translation.editable(),
      fromSubPart: translation.fromSubPart(),
    };
  }

  /**
   * Return a list of translation group objects. If `groupIds` is passed as an
   * argument, the translation groups will be limited those which have an id
   * in the list.
   * @deprecated This function follows the old definition of translation groups which do not have
   * all the new metadata now associated with translations.
   * See getTranslationRegionGroups() in client/molbio/translations/TranslationUtil.ts instead
   */
  getTranslationGroups(groupIds?: Array<number>): Array<TranslationGroupDict> {
    // eslint-disable-next-line no-restricted-syntax
    const translationGroupIds = this.translations()
      .chain()
      .map((t: Translation) => t.translationGroupId())
      .filter((id: number | null) => {
        if (groupIds != null) {
          if (id != null) {
            return Array.from(groupIds).includes(id);
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .compact()
      .uniq()
      .sort()
      .value();

    return translationGroupIds.map((id: number, i: number) => {
      const translationsInGroup = this.translations().filter((t) => t.translationGroupId() === id);
      const totalLength = benchlingUtil.sum(translationsInGroup.map((t) => t.length(this)));
      const translationDicts = _(translationsInGroup)
        .chain()
        .map((t) => this._translationToDict(t))
        .sortBy('start')
        .value();
      const aminoAcidLength = Math.floor(totalLength / 3);
      return {
        id,
        translations: translationDicts,
        aminoAcidLength,
        name: `Group ${i + 1}`,
      };
    });
  }

  selectionContainedInPart(): boolean {
    const selection = this.selection();
    if (!selection.isNotEmpty()) {
      const index = selection.start();
      if (index === this.length()) {
        return false;
      }
      const parts = this.getSequencePartsAt(index);
      return parts.some((part) => part.start() !== index);
    } else {
      const start = selection.start();
      const end = selection.end();
      const parts = this.parts().getSequencePartsBetween(start, end);
      return parts.some((p) => sequtil.isRangeWithin(start, end, p.start(), p.end()));
    }
  }

  resetAnnotations(): Array<Annotation> {
    if (this._annotations != null) {
      this.stopListening(this._annotations);
    }
    this._annotations = this.get('_sequence').get('annotations');
    this.annotations()._annotations = this._annotations;

    this.listenTo(this._annotations, 'batch', function (this: Sequence): void {
      this.annotations().trigger('batch');
    });
    this.listenTo(
      this._annotations,
      'add',
      function (
        this: Sequence,
        _a: BioJSAnnotation,
        collection: AnnotationCollection,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        options: any
      ): void {
        this.annotations().add({_annotation: _a, id: _a.get('id'), visible: true}, options);
      }
    );

    const annotations = this._annotations.map((_annotation) => {
      const id = _annotation.get('id')!;
      const annotation = this.get('annotations').get(id);
      const visible = annotation != null ? annotation.get('visible') : true;
      return {_annotation, id, visible};
    });
    // @ts-expect-error Backbone types are wrong; reset can accept attribute hashes as well as models
    return this.get('annotations').reset(annotations);
  }

  listenToTranslations(): Sequence {
    if (this._translations != null) {
      this.stopListening(this._translations);
    }
    this._translations = this.get('_sequence').translations();
    this.listenTo(this._translations, 'batch', function (this: Sequence): void {
      this.translations().trigger('batch');
    });
    return this.listenTo(
      this._translations,
      'add',
      function (
        this: Sequence,
        translation: BioJSTranslation,
        collection: BioJSTranslations,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        options: any
      ): void {
        this.translations().add({_translation: translation, id: translation.id}, options);
      }
    );
  }

  resetTranslations(): Array<Translation> {
    this.listenToTranslations();
    const translations = this._translations.map((translation) => ({
      _translation: translation,
      id: translation.id,
    }));

    // @ts-expect-error Backbone types are wrong; reset can accept attribute hashes as well as models
    return this.translations().reset(translations);
  }

  _updatePartnerSelected(): void {
    const otherSelected: {[K: number]: boolean} = {};
    const primers = this.sequencePrimers();
    this.get('_sequence')
      .primerPairs()
      .each((pair) => {
        const [forward, reverse] = Array.from(pair.getPrimers(primers));
        if (!otherSelected[forward.id]) {
          // @ts-expect-error: Fixme (Typescript 4.8 upgrade)
          // Error:
          // Property 'selected' does not exist on type 'SequencePrimer | SequencePrimer'.
          //   Property 'selected' does not exist on type 'SequencePrimer'.ts(2339)
          otherSelected[forward.id] = reverse.selected();
        }
        // @ts-expect-error: Fixme (Typescript 4.8 upgrade)
        // eslint-disable-next-line no-return-assign
        return otherSelected[reverse.id] || (otherSelected[reverse.id] = forward.selected());
      });
    this.sequencePrimers().each((primer) => primer.set({partnerSelected: otherSelected[primer.id] || false}));
  }

  resetPrimers(): void {
    if (this._primers != null) {
      this.stopListening(this._primers);
    }
    this._primers = this.get('_sequence').sequencePrimers();
    this.listenTo(this._primers, 'add remove', this.batchResetPrimer);
    this.listenTo(this._primers, 'batch', function (this: Sequence): void {
      this.sequencePrimers().trigger('batch');
    });
    this.listenTo(
      this._primers,
      'change:bases change:bind_position change:overhang_length',
      function (this: Sequence): void {
        this.goldenGateCutSites().updateCutSites(this.get('_sequence'));
      }
    );
    const primers = this._primers.map((primer) => ({_primer: primer}));
    // @ts-expect-error Backbone types are wrong; reset can accept attribute hashes as well as models
    this.sequencePrimers().reset(primers);
  }

  circular(): BioJSSequenceAttributes['circular'] {
    return this.get('_sequence').get('circular');
  }

  startIndex(): HoistedMethod<'startIndex'> {
    return this.get('_sequence').startIndex();
  }

  selection(): SequenceAttributes['selection'] {
    return this.get('selection');
  }

  finalized(): HoistedMethod<'finalized'> {
    return this.get('_sequence').finalized();
  }

  assemblyType(): HoistedMethod<'assemblyType'> {
    return this.get('_sequence').assemblyType();
  }

  makeEnzymes(): Enzymes {
    const _sequence = this.get('_sequence');
    const reallyBig = this.isReallyBig();
    const enzymes = Enzymes.getCommonEnzymes();
    enzymes.each((enzyme) => {
      // If the sequence is small enough, compute the cutsites.
      if (!reallyBig) {
        // @ts-expect-error Backbone doesn't prevent putting extra attributes into options
        enzyme.set('cutPositions', _sequence.getCuts(enzyme.toJSON()), {trigger: false});
      } else {
        // Otherwise, we will set them later.
        // @ts-expect-error Backbone doesn't prevent putting extra attributes into options
        enzyme.set('cutPositions', [], {trigger: false});
      }

      // Set visibility based on enzyme list and filter.
      const listId = preferences.get(EnzymePreferences.ENZYME_LIST_ID);
      if (EnzymeUtil.isEnzymeListId(listId) && !EnzymeUtil.doesEnzymeListContain(listId, enzyme.id)) {
        // @ts-expect-error Backbone doesn't prevent putting extra attributes into options
        enzyme.set('visible', false, {trigger: false});
      } else {
        const viewType = preferences.get(EnzymePreferences.VIEW_ENZYMES);
        enzyme.updateVisibleByCuts(viewType);
      }
    });
    return enzymes;
  }

  // Include placeholder initialize param types so that GapSequenceWrapper can declare its own params.
  override initialize(attributes?: unknown, options?: unknown): void {
    let analysisModels: Array<Analysis>;
    this.updateVersions = this.updateVersions.bind(this);

    if (this.get('_sequence') == null) {
      return;
    }

    const _sequence = this.get('_sequence');

    if (this.id == null) {
      this.set({id: _sequence.id});
    }

    const reallyBig = this.isReallyBig();

    const dna = new DNA({_sequence});
    const enzymes = this.makeEnzymes();
    const versions = new Versions(_sequence.versions(), {sequenceID: this.id});
    const selection = this.get('selection') || new Selection({sequence: this});
    const cutsites = new CutSites(undefined, {enzymes, selection});
    const mismatches = new PrimerAssemblyMismatches();
    const goldenGateCutSites = new GoldenGateCutSites();
    if (_sequence.get('analyses') != null) {
      analysisModels = Array.from(_sequence.get('analyses')).map((analysis: SequenceAnalysisSummary) =>
        Analysis.parseAnalysis(analysis)
      );
    } else {
      analysisModels = [];
    }

    this.set({
      _sequence,
      activeVersionId: _sequence.latestVersionId(),
      dna,
      annotations: new Annotations(),
      translations: new Translations(),
      sequencePrimers: new SequencePrimers([], {sequence: this}),
      selection,
      analyses: new Analyses(analysisModels, {sequenceID: this.id}),
      // @ts-expect-error: Sequence uses a Tags collection instead of array of Tags
      tags: new Tags(_sequence.get('tags'), {sequenceID: this.id}),
      versions,
      enzymes,
      cutsites,
      editURL: _sequence.get('editURL'),
      writable: _sequence.get('writable'),
      permissions: _sequence.get('permissions'),
      primerAssemblyMismatches: mismatches,
      goldenGateCutSites,
      lockingTabQueue: [],
      tagSchema: _sequence.get('tagSchema'),
      projectFolderId: _sequence.get('projectFolderId'),
      transcriptionMatches: [],
      isContainedInComplexPolymerData: _sequence.get('isContainedInComplexPolymerData'),
    });

    this.batchResetPrimer = this.listenToBatch(this.sequencePrimers(), function (this: Sequence): void {
      this.resetPrimers();
    });
    this.resetAnnotations();
    this.resetTranslations();
    this.resetPrimers();
    this.updateORFs();
    this.cacheTranscriptionMatches();
    this.registerTranscriptionListeners();
    mismatches.updateMismatches(_sequence);
    goldenGateCutSites.updateCutSites(_sequence);
    this.get('cutsites').trigger('cutsitesChanged');

    this.listenTo(_sequence, 'change:annotations', this.resetAnnotations.bind(this));
    this.listenTo(_sequence, 'change:translations', this.resetTranslations.bind(this));
    this.listenTo(_sequence, 'change:sequencePrimers', this.resetPrimers.bind(this));
    this.listenTo(_sequence, 'change:editURL', (sequence: BioJSSequence, url: string) =>
      this.set('editURL', url)
    );
    this.listenTo(_sequence, 'change:circular', this.updateDynamicFeatures.bind(this));
    this.listenTo(_sequence, 'change:circular', () => {
      this.sequencePrimers().setLayers();
    });
    this.listenTo(_sequence, 'change:bases reset', this.updateDynamicFeatures.bind(this));
    this.listenTo(
      preferences,
      `change:${SequenceMapPreferences.ORF_START_CODON}`,
      this.updateORFs.bind(this)
    );
    this.listenTo(
      _sequence,
      'change:locked change:unrecoverable change:permissions change:archiveRecord',
      this.setBanner.bind(this)
    );
    this.listenTo(_sequence, 'change:bases change:fragmentResults change:finalized', () => {
      mismatches.updateMismatches(_sequence);
      goldenGateCutSites.updateCutSites(_sequence);
    });
    this.listenTo(selection, 'delete', this.deleteSelection.bind(this));

    // Keep track of version state
    this.listenTo(_sequence, 'change:latestVersionId', this.setCurrentVersion.bind(this));
    this.on('change:activeVersionId', this.setCurrentVersion.bind(this));
    this.on('change:currentVersion change:writable change:permissions', this.setBanner.bind(this));

    this.listenTo(enzymes, 'change:color', this.setEnzymeColors.bind(this));
    this.listenTo(this.sequencePrimers(), 'change:selected', this._updatePartnerSelected.bind(this));
    this.listenTo(this, 'cutstherepls', this.updateCutsInRange.bind(this));

    this.initGraphQLSync();

    // If the sequence is big, we will let the linear map set the pertinent cutsites.
    if (reallyBig) {
      this.trigger('cutswherepls');
    }
  }

  // Can be overridden in subclasses
  initGraphQLSync(): void {
    initBackboneToGraphQLSync(SyncedModelName.COMPONENT_SEQUENCE, this);
    this.listenTo(this.get('_sequence'), 'change:bases change:name change:modifiedNucleotides', () =>
      this.trigger('change')
    );
    // TODO: make it easier to listen for resets on all collections that are synced to Apollo
    this.listenTo(this.sequencePrimers(), 'reset sort update', () => this.trigger('change'));
  }

  listenToRestrictionPanelState(): Sequence {
    return this.listenTo(
      this.get('fileState').get('toolbar').get('restrictionPanelState'),
      'change:highlightCompatible',
      this.changeHighlightCompatible.bind(this)
    );
  }

  primerPairs(): BioJSSequenceAttributes['primerPairs'] {
    return this.get('_sequence').get('primerPairs');
  }

  async getVersionToResetTo(): Promise<Version | undefined> {
    const versions = this.get('versions')
      .sortBy((a) => a.get('id'))
      .reverse();
    const versionMetadata = versions.map((v) => ({id: v.get('id'), parentId: v.get('parentId')}));
    const versionToUndo = versionMetadata[0];
    const versionIdToResetTo = VersionHistoryUtil.getVersionIdToResetTo(versionToUndo, versionMetadata);
    const versionToResetTo = versions.filter((v) => v.get('id') === versionIdToResetTo)[0];
    await versionToResetTo?.fetch();
    return versionToResetTo;
  }

  async undo(): Promise<void> {
    const versionToResetTo = await this.getVersionToResetTo();

    if (versionToResetTo != null) {
      await this.resetToVersion(versionToResetTo);
    }
  }

  async resetToVersion(version: Version): Promise<void> {
    try {
      await this.get('_sequence').save({reset: version.get('id')}, {patch: true, fileUpdate: true});
      notifications.success(
        <>
          <strong>{this.name()}</strong> has been successfully reset to an older version
        </>
      );
      // eslint-disable-next-line benchlint/always-throw-from-catch
    } catch (e) {
      notifications.notifyError(e);
    }
    await this.updateVersions({switchToLast: true});
    this.selection().clampToSequence();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewVersion(version: Version): JQueryPromise<any> {
    this.setActiveVersionId(version.id);
    return version.fetch().done(() => {
      this.setCurrentVersion();

      // Primers/annotations/translations shouldn't trigger any events until their
      // associated parts have been set... otherwise, we may run into errors when
      // trying to compute starts/ends for layering.

      // batchModify ensures that setLayers doesn't get called until after this block finishes,
      // which allows parts time to update the bases.

      const collections = [this.annotations(), this.sequencePrimers(), this.translations()];
      Backbone.batchModify<Backbone.Model, Sequence>(collections, this, function (this: Sequence): void {
        // TODO: We can use this same approach for primers and translations... maybe.
        this._sequence()
          .annotations()
          // @ts-expect-error Backbone types are wrong; set can accept attribute hashes as well as models
          .set(version.get('annotations'));

        let finalized = version.get('finalized');
        finalized = finalized != null ? finalized : true;

        const fragmentResults = new BioJS.FragmentResultCollection(version.get('fragment_results'), {
          parse: true,
        });

        this._sequence().set({
          bases: version.get('bases'),
          sequencePrimers: new BioJS.SequencePrimerCollection(version.get('sequence_primers'), {
            sequenceID: this.id,
          }),
          primerPairs: new BioJS.PrimerPairCollection(version.get('primer_pairs'), {sequenceID: this.id}),
          translationGroups: version.get('translation_groups'),
          translations: new BioJS.TranslationCollection(version.get('translations'), {sequenceID: this.id}),
          parts: new BioJS.PartCollection(
            version.get('parts').filter((p) => p.sequence_id != null),
            {parse: true}
          ),
          circular: version.get('circular'),
          startIndex: version.get('startIndex'),
          modifiedNucleotides: version.get('modified_nucleotides'),
          fragmentResults,
          finalized,
        });
      });
      this.selection().clampToSequence();
      this.selection().clearState();
      this.trigger('jump', 0);
    });
  }

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  override fetch(...rest: any): JQueryPromise<any> {
    // If we're on a previous version, we just need to fetch the version, not the
    // up to date biojs sequence.
    if (this._sequence()) {
      const activeVersion = this.getActiveVersion();
      if (activeVersion != null && activeVersion !== this.get('versions').max((v) => v.id)) {
        return this.viewVersion(activeVersion);
      }
    }

    const _sequence = this._sequence() || new BioJS.Sequence({id: this.get('id')});
    return _sequence.fetch(...rest).then(() => {
      // We only need to set _sequence and initialize if we don't have one already.
      if (this._sequence() == null) {
        this.set('_sequence', _sequence);
        this.initialize();
      } else {
        // fetch() updates the sequence that is being displayed on the client to the latest version.
        // Accordingly, we need to update the activeVersionId to be consistent with the version that is
        // actually being displayed.
        this.set('activeVersionId', this._sequence().latestVersionId());
      }
      return this;
    });
  }

  length(): number {
    if (this.get('_sequence') != null) {
      return this.get('_sequence').bases().length;
    } else {
      return 0;
    }
  }

  override isEmpty(): HoistedMethod<'isEmpty'> {
    return this.get('_sequence').isEmpty();
  }

  isSelectionEditable(): boolean {
    const selection = this.selection();
    if (!selection.isNotEmpty()) {
      return this.canInsertAt(selection.start());
    } else {
      return this.isRegionEditable(selection.start(), selection.end());
    }
  }

  isSelectionDeletable(): boolean {
    const selection = this.selection();
    if (!selection.isNotEmpty()) {
      return false;
    }
    if (this.isOligo()) {
      return true;
    }
    return this.canInsertAt(selection.start()) && this.canInsertAt(selection.end());
  }

  getActiveVersion(): Version {
    return this.get('versions').findWhere({id: this.getActiveVersionId()});
  }

  getActiveVersionId(): number {
    return this.get('activeVersionId');
  }

  setActiveVersionId(versionId: number): void {
    this.set('activeVersionId', versionId);
  }

  setLatestVersionId(versionId: number, param?: {activateIfOnCurrent?: boolean}): void {
    if (param == null) {
      param = {};
    }
    let {activateIfOnCurrent} = param;
    if (activateIfOnCurrent == null) {
      activateIfOnCurrent = false;
    }
    if (activateIfOnCurrent && this.get('currentVersion')) {
      this.setActiveVersionId(versionId);
    }
    this._sequence().setLatestVersionId(versionId);
  }

  setCurrentVersion(): Sequence {
    // To determine the lastVersion, we check the versions and the latestVersionId on the sequence.
    // The versions array is fetched asynchronously so it is not necessarily the best truth.
    const activeVersion = this.getActiveVersionId();
    const lastVersion = this._sequence().latestVersionId();
    return this.set('currentVersion', activeVersion >= lastVersion);
  }

  async updateVersions(
    options: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      callback?: (() => any) | null;
      switchToLast?: boolean;
      showHistoryPanel?: boolean;
    } = {}
  ): Promise<void> {
    _.defaults(options, {callback: null, switchToLast: false, showHistoryPanel: true});
    // switchToLast should be set to true only if
    // the version we are on is not the latest version
    // ie, when we delete a version.
    const versions = this.get('versions');
    await versions.fetch({reset: true});

    /* Update latestVersionId and activeVersionId.

    Updating these should be no-ops because SequenceAttributeCollection should have already properly
    set them from the server's X-Sequence-Version header. Technically, always calling setActiveVersionId
    to the latest version here could go wrong if Client1 has a slow connection:

      Client1 Makes Request1 that updates sequence on Version1.
      Server  Processes Request1, resulting in Version2.
      Client2 Loads sequence on Version2, and makes Request2.
      Server  Processes Request2, resulting in Version3.
      Client1 Gets back Response1, (X-Sequence-Version says we're on Version 2),
              and fetches versions with latest being Version3.

    If we now set active version to Version3, the client will be wrong (rendering Version2)
    This behavior can also be triggered with one client if fetching versions is sufficiently slow.
    */

    let lastVersion = this.get('versions').max((v) => v.get('id'));
    const onCurrentVersion = this.get('currentVersion');

    // Mark the latest fetched version to be the latest version.
    // It is okay for the lastVersion.id to be earlier than the sequence.latestVersionId()
    // (e.g if fetches take a long time). In the case that the X-Sequence-Version is wrong
    // (missing or NOT ahead), we should use the latest fetched versions's id.
    if (lastVersion.id > this._sequence().latestVersionId()) {
      this._sequence().setLatestVersionId(lastVersion.id);
    }

    // Mark the last version to be the active if onCurrentVersion (is viewing the latest version)
    if (options.switchToLast) {
      lastVersion = _.max(versions.models, (v) => v.get('id'));
      if (options.showHistoryPanel) {
        versions.trigger('open', lastVersion);
      }
      await this.viewVersion(lastVersion);
    } else if (onCurrentVersion) {
      // Change the active version, otherwise the user will be locked out of their sequence.
      if (this.getActiveVersionId() !== this._sequence().latestVersionId()) {
        this.setActiveVersionId(this._sequence().latestVersionId());
      }
    }
    this.setCurrentVersion();
    if (typeof options.callback === 'function') {
      options.callback();
    }
    versions.trigger('reloaded');
  }

  /**
   * Call this.deleteBases for the current selection, handling both the success case (assembly/selection
   * update) and the failure case (notification)
   */
  deleteSelection(
    options: {respondDiff?: boolean; fileUpdate?: boolean; patch?: boolean; callback?: () => void} = {}
  ): DoSeqOpReturnPromise | undefined {
    _.defaults(options, {respondDiff: true, fileUpdate: true, patch: true, callback: noop});

    const selection = this.get('selection');
    if (!selection.isNotEmpty()) {
      return;
    }

    const _sequence = this.get('_sequence');
    if (!asm.of(_sequence).canDelete(_sequence, selection, notifications.warn)) {
      return;
    }

    const deletionLength = sequtil.length(selection.start(), selection.end(), _sequence.length());

    const pos = Math.min(selection.start(), _sequence.length() - deletionLength);
    const xhr = this.deleteBases(selection.start(), selection.end(), options);

    // Handle xhr success/failure
    xhr.fail(notifications.notifyError);
    xhr.client.done(() => {
      selection.reset(pos);
    });

    // TODO: Show a loading screen while assembly update is taking place to be "atomic"
    if (asm.of(_sequence).assemblyType != null) {
      xhr.done(() => {
        selection.reset(pos); // Reset the selection in case the user moved it.
        // Note it's important to do this after updating the selection so that the handler gets the new
        // selection.
        asm
          .of(_sequence)
          .didDelete(_sequence, selection, deletionLength, notifications.success, notifications.error);
      });
    }
    return xhr;
  }

  handleCopy(copyMode: CopyNucleotideSequenceMode): void {
    const {start, end, selection, source, helpText} = getCopyDataForSequenceAndSelection(
      this,
      this.get('selection')
    );
    let bases: string;
    let modifiedNucleotides: Readonly<Array<Readonly<ModifiedNucleotideAttributes>>>;
    if (source instanceof Sequence) {
      const sourceSubSelection = source.createFromSelection(start, end, {
        annotations: true, // Include annotations to get out relevant modified nucleotides.
        notcontained: false,
        reverseComplement: false,
        primers: getPrimersForCopy(source),
        save: false,
      });
      bases = sourceSubSelection.bases();
      modifiedNucleotides = sourceSubSelection.modifiedNucleotides();
    } else {
      bases = source.bases();
      modifiedNucleotides = source.modifiedNucleotides();
    }

    function copyHandler(
      annotationsChecked: boolean,
      notContainedAnnotationsChecked: boolean,
      selectedCopyClass: CopyNucleotideSequenceMode,
      copiedResidues: string
    ): void {
      if (selection != null && (selection.start() !== start || selection.end() !== end)) {
        // Selection has shifted since the start of the handleCopy method. Fail with an error to avoid confusion.
        notifications.error(
          'The selection has changed since the beginning of the copy operation. Please re-create your selection and try again.'
        );
        return;
      }
      switch (selectedCopyClass) {
        case CopyNucleotideSequenceMode.DNA:
        case CopyNucleotideSequenceMode.DNA_REVERSE_COMPLEMENT:
        case CopyNucleotideSequenceMode.RNA:
        case CopyNucleotideSequenceMode.RNA_REVERSE_COMPLEMENT:
        case CopyNucleotideSequenceMode.ORIGINAL: {
          SequenceMapUtil.storeNucleotideRegionInBenchlingClipboard(
            source,
            selectedCopyClass,
            annotationsChecked,
            notContainedAnnotationsChecked,
            start,
            end,
            selection
          );
          break;
        }
        default:
          // Note: this is a noop unless the copied residues is very long.
          clipboard.store(copiedResidues);
      }
    }

    legacyRunModal<CopySelectionModalProps>(CopySelectionModal, {
      additionalHelpText: helpText,
      bases,
      nucleotideType: source.nucleotideType(),
      shouldRenderHelmOption: this.supportsChemicalMods() && !bases.includes('-'),
      shouldRenderOriginalModeOption: source.canUseFullUTFlexibility(),
      modifiedNucleotides,
      // Annotations copy options are only applicable when copying from a non-oligo sequence.
      areSequenceFeatureOptionsApplicable: source instanceof Sequence && !source.isOligo(),
      isOligo: source instanceof SequencePrimer || source.isOligo(),
      initialSelect: copyMode,
      copyHandler,
    });
  }

  getNoteParts(): Array<ServerNotePart> | undefined {
    return this.get('_sequence').get('note')?.noteParts;
  }

  handleCreateFromSelectionClick(newSequenceType?: SequenceType, strand?: Strand): void {
    const selection = this.get('selection').assertNotEmpty();
    const fullCircular = sequtil.fullCircular(
      this.circular(),
      selection.start(),
      selection.end(),
      this.length()
    );

    // arrow function so we can use 'this' within
    const getModalNucleotideType = (): NucleotideType => {
      if (newSequenceType) {
        assert(
          newSequenceType === SequenceType.DOUBLE_STRANDED ||
            newSequenceType === SequenceType.SINGLE_STRANDED,
          'Cannot create new oligo from sequence selection'
        );
        if (newSequenceType === SequenceType.DOUBLE_STRANDED) {
          return NucleotideType.DNA;
        } else {
          return NucleotideType.RNA;
        }
      } else {
        return this.nucleotideType();
      }
    };

    const modalNucleotideType = getModalNucleotideType();

    const modal = $(
      // eslint-disable-next-line new-cap
      CopyOptionsModalTemplate({
        circular: fullCircular,
        sourceSequenceType: this.type(),
        strand,
        targetNucleotideType: modalNucleotideType,
      })
    );
    const primers = getPrimersForCopy(this);

    const hasPrimers = primers[0] != null || primers[1] != null;
    modal.find('.primer-bases-wrapper').toggleClass('hidden', !hasPrimers);
    modal.find('.primer-bases').prop('checked', preferences.get(CopyPreferences.PRIMER_BASES));

    modal.find('.annotations').prop('checked', preferences.get(CopyPreferences.ANNOTATIONS));
    modal
      .find('.not-contained-annotations')
      .prop('checked', preferences.get(CopyPreferences.ANNOTATIONS_NOT_CONTAINED));
    modal.find('.tags').prop('checked', preferences.get(CopyPreferences.TAGS));
    modal.find('.description').prop('checked', preferences.get(CopyPreferences.DESCRIPTION));
    modal.find('.js-preserve-indices').prop('checked', this.startIndex() !== 1);
    if (!preferences.get(CopyPreferences.ANNOTATIONS)) {
      modal.find('.not-contained-annotations').prop('disabled', true);
    }
    $('body').append(modal);
    modal.modal('show');

    modal.find('.annotations').on('change', () => {
      if (modal.find('.annotations').prop('checked')) {
        return modal.find('.not-contained-annotations').prop('disabled', false);
      } else {
        modal.find('.not-contained-annotations').prop('checked', false).prop('disabled', true);
        return modal.find('.not-contained-annotations').trigger('change');
      }
    });
    modal.find('.checkbox input').on('change', (e) => {
      const $checkbox = $(e.currentTarget);
      const checked = $checkbox.prop('checked');
      if ($checkbox.hasClass('annotations')) {
        preferences.set(CopyPreferences.ANNOTATIONS, checked);
      } else if ($checkbox.hasClass('not-contained-annotations')) {
        preferences.set(CopyPreferences.ANNOTATIONS_NOT_CONTAINED, checked);
      } else if ($checkbox.hasClass('tags')) {
        preferences.set(CopyPreferences.TAGS, checked);
      } else if ($checkbox.hasClass('description')) {
        preferences.set(CopyPreferences.DESCRIPTION, checked);
      } else if ($checkbox.hasClass('primer-bases')) {
        preferences.set(CopyPreferences.PRIMER_BASES, checked);
      }
    });
    modal.find('.copy').on('click', () => {
      const reverseComplement =
        strand != null ? strand !== 1 : modal.find('.reverse-complement').prop('checked');
      const newSequence = this.createFromSelection(selection.start(), selection.end(), {
        annotations: modal.find('.annotations').prop('checked'),
        notcontained: modal.find('.not-contained-annotations').prop('checked'),
        tags: modal.find('.tags').prop('checked'),
        reverseComplement,
        primers,
        primerBases: modal.find('.primer-bases').prop('checked'),
        preserveIndices: modal.find('.js-preserve-indices').prop('checked'),
        type: newSequenceType || this.type(),
      });
      const currentNoteParts = this.getNoteParts() || [];
      const noteParts =
        modal.find('.description').prop('checked') && currentNoteParts.length > 0
          ? currentNoteParts
          : undefined;
      return Sequence.saveAndOpenSequence(newSequence.toSaveable(), this.folder()?.api_identifier, {
        noteParts,
      });
    });
    modal.on('hidden.bs.modal', () => modal.remove());
  }

  handleOptimizeCodonsFromSelectionClick(strand: Strand): void {
    const tab = new CodonOptimizationTabState({sequence: this, strand});
    this.fileState().buffers().addTab(tab);
    analytics.trackEvent(MOLBIO_ANALYTICS_ACTIONS.OPENED_CODON_OPTIMIZATION, {
      type: 'sequence',
      polymerId: this.get('id'),
    });
  }

  handlePrimer3FromSelectionClick(): void {
    const buffers = this.fileState().buffers();
    const tab = new PrimerWizardTabState({sequence: this, buffers});
    buffers.addTab(tab);
  }

  getCreatePartModalProps(): CreateLinkableBioentityModalProps {
    const selection = this.get('selection').assertNotEmpty();
    const newSequence = this.createFromSelection(selection.start(), selection.end(), {
      annotations: true,
      notcontained: false,
      tags: false,
      reverseComplement: false,
    });
    const description =
      'A new part will be created and this region ' +
      `(${sequtil.modelStartToDisplay(selection.start(), this.startIndex())}-${sequtil.modelEndToDisplay(
        selection.end(),
        this.get('_sequence').length(),
        this.startIndex()
      )}) ` +
      'will be replaced with it.';
    const partLinkFields = (this.tagSchema()?.fields ?? [])
      .filter(
        (field): field is BioentityLinkFieldWithTagSchema =>
          field.fieldType === SchemaFieldConstants.FIELD_TYPES.PART_LINK.type
      )
      .map((field) => ({
        field,
        hasExistingValue: this.tags().some(
          (tag) => tag.name === field.name && tag.targetFiles && tag.targetFiles.length > 0
        ),
      }));

    return {
      title: 'Replace selection with part',
      description,
      initialFolderId: this._sequence().get('projectFolderId') || this.folder()!.api_identifier,
      namePlaceholder: newSequence.name(),
      entityLinkFields: partLinkFields,
      oligoAwareFolderItemTypes: [this.subtype()],
      entityLinkFieldLabel: 'Part link',
      onRequestSubmit: ({
        folderId,
        name,
        tagSchemaId,
        entityLinkField,
        studyIds,
      }: ConfirmCreateLinkableBioentityPayload): void => {
        LoadingScreen.show();
        // @ts-expect-error TODO: see if it's ok for folder to only be an id
        newSequence.set('folder', folderId);
        newSequence.set('name', name);
        newSequence.set('tagSchemaId', tagSchemaId);
        newSequence.set('studyIds', studyIds);
        this.createPartAndReplace(selection.start(), selection.end(), newSequence, entityLinkField?.id)
          .done(() => {
            notifications.success(`Created a new part: ${name}`);
          })
          .fail(notifications.notifyError)
          .always(() => {
            LoadingScreen.hide();
          });
      },
      onRequestClose: () => noop,
    };
  }

  handleCreatePartFromSelectionClick(): void {
    legacyRunModal(CreateLinkableBioentityModal, this.getCreatePartModalProps());
  }

  /**
   * @param {Object} options - An object containing data about the sequence to be created:
   *                           noteParts: An array of objects of type APINotePart representing note parts to
   *                                      create in the description of the new sequence.
   */
  static saveAndOpenSequence(
    _sequence: BioJSSequence,
    defaultFolderId?: string | null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any = {}
  ): JQueryPromise<unknown> {
    const FolderSelectorModalClass = require('file-browser/FolderSelectorModal').default;

    const initialFolderId =
      defaultFolderId != null ? defaultFolderId : FolderDefaults.get(FolderDefaultsKey.INVENTORY);
    const deferred = $.Deferred();

    FolderSelectorModalClass.openForSelect(
      'append',
      {initialFolderId, showInventory: true},
      (e: GenericEvent) => {
        LoadingScreen.show();
        const {folderId, tagSchemaId} = RegistryUtil.parseFolderValue(e.target.value);
        _sequence
          // TODO(TypeScript): Why are we saving the folderId to the folder field here?
          // @ts-expect-error
          .save({folder: folderId, tagSchemaId}, options)
          .then(() => FileStates.get().openFolderItem(_sequence.get('id')))
          .done(() => {
            deferred.resolve();
            FolderDefaults.set(FolderDefaultsKey.INVENTORY, folderId!);
            FolderDAOCache.invalidateFolderContents(folderId);
          })
          .fail((res: Response) => {
            notifications.notifyError(res);
            deferred.reject();
          })
          .always(() => {
            LoadingScreen.hide();
          });
      }
    );

    return deferred.promise();
  }

  handleCreateProteinFromSelectionClick(strand: Strand): void {
    let actualEnd;
    let actualStart;
    const selection = this.get('selection').assertNotEmpty();
    const start = selection.start();
    const end = selection.end();
    const bases = this.residueSlice(start, end);
    const aminoAcids = biojsUtil.translateOnStrand(
      bases,
      strand,
      this.nucleotideType(),
      CodonTranslationTable.STANDARD,
      false,
      true
    );

    if (aminoAcids.length === 0) {
      notifications.error('You must select at least three bases.');
      return;
    }

    if (strand === 1) {
      actualStart = start;
      actualEnd = sequtil.mod(actualStart + aminoAcids.length * 3, this.length());
    } else {
      assert(strand === -1, 'Expected strand to be 1 or -1.');
      actualEnd = end;
      actualStart = sequtil.mod(actualEnd - aminoAcids.length * 3, this.length());
    }

    this.promptSaveProtein(actualStart, actualEnd, aminoAcids, strand);
  }

  handleCreateProteinFromTranslationClick(translation: Translation): void {
    const {translations, codonTranslationTable, strand, coerceStartCodonToMethionine} =
      translation.getTranslationRegionGroup(this)!;
    const {start} = translations[0];
    const {end} = translations[translations.length - 1];
    const bases = translations.map((t) => this.residueSlice(t.start, t.end)).join('');
    const aminoAcids = biojsUtil.translateOnStrand(
      bases,
      strand,
      this.nucleotideType(),
      codonTranslationTable,
      coerceStartCodonToMethionine,
      true
    );
    const fromTranslation = true;

    // For now, just show the start and end of the translation or translation group rather than
    // figuring out where the stop codon was in the sequence.
    this.promptSaveProtein(start, end, aminoAcids, strand, fromTranslation);
  }

  hasNonTrailingStopCodons(aminoAcids: string): boolean {
    const firstStopCodonIdx = aminoAcids.indexOf('*');

    if (firstStopCodonIdx === -1) {
      return false;
    }

    return _.any(Array.from(aminoAcids.slice(firstStopCodonIdx)), (char) => char !== '*');
  }

  getStopCodonError(start: number, end: number, strand: Strand, aminoAcids: string): string | null {
    let stopCodonEnd;
    let stopCodonStart;

    const firstStopCodonIndex = aminoAcids.indexOf('*');

    if (!this.hasNonTrailingStopCodons(aminoAcids)) {
      return null;
    }

    if (strand === 1) {
      stopCodonStart = sequtil.mod(start + 3 * firstStopCodonIndex, this.length());
      stopCodonEnd = stopCodonStart + 3;
    } else {
      stopCodonEnd = sequtil.mod(end - 3 * firstStopCodonIndex, this.length());
      stopCodonStart = sequtil.mod(stopCodonEnd - 3, this.length());
    }

    const [displayStart, displayEnd] = Array.from(
      sequtil.modelRangeToDisplay(stopCodonStart, stopCodonEnd, this.length(), this.startIndex())
    );

    return `Can't create a protein because a premature stop codon was found at bases ${displayStart}-${displayEnd}`;
  }

  truncateTrailingStopCodons(aminoAcids: string): string {
    assert(
      !this.hasNonTrailingStopCodons(aminoAcids),
      'truncateTrailingStopCodons truncates everything after the first stop codon and should not be called on proteins with premature stop codons'
    );

    if (aminoAcids.indexOf('*') > -1) {
      aminoAcids = aminoAcids.slice(0, aminoAcids.indexOf('*'));
    }

    return aminoAcids;
  }

  async promptSaveProtein(
    start: number,
    end: number,
    aminoAcids: string,
    strand: StrandOfDoubleStranded,
    fromTranslation: boolean = false
  ): Promise<void> {
    let folder;
    const FileBrowserActions = require('file-browser/FileBrowserActions').default;

    if (aminoAcids.indexOf('?') !== -1) {
      notifications.error("Couldn't translate degenerate bases into AA sequence.");
      return;
    }

    const entityLinkFields = (this.tagSchema()?.fields ?? [])
      .filter(
        (field): field is BioentityLinkFieldWithTagSchema =>
          field.fieldType === SchemaFieldConstants.FIELD_TYPES.TRANSLATION_LINK.type
      )
      .map((field) => ({
        field,
        hasExistingValue: this.tags().some(
          (tag) => tag.name === field.name && tag.targetFiles && tag.targetFiles.length > 0
        ),
      }));

    const stopCodonError = this.getStopCodonError(start, end, strand, aminoAcids);

    if (stopCodonError) {
      notifications.error(stopCodonError);
      return;
    } else {
      aminoAcids = this.truncateTrailingStopCodons(aminoAcids);
    }

    const messageSuffix = strand === -1 ? ' reversed' : '';
    const displayStart = sequtil.modelStartToDisplay(start, this.startIndex());
    const displayEnd = sequtil.modelEndToDisplay(end, this.length(), this.startIndex());
    const namePlaceholder = `${this.name()} translation [${displayStart}-${displayEnd}${messageSuffix}]`;

    const selectedFolderId = (() => {
      if (this.projectFolderId()) {
        return this.projectFolderId();
      }
      folder = this.folder();
      if (folder && !RegistryUtil.isRegistryFolder(folder)) {
        return folder.api_identifier;
      } else {
        return FolderDefaults.get(FolderDefaultsKey.INVENTORY);
      }
    })();

    const result = await legacyRunModal<CreateLinkableBioentityModalProps>(CreateLinkableBioentityModal, {
      title: 'Create AA sequence',
      initialFolderId: selectedFolderId ?? undefined,
      namePlaceholder,
      entityLinkFields,
      oligoAwareFolderItemTypes: [ModelTypeConstants.PROTEIN],
      entityLinkFieldLabel: 'Translation link',
    });

    if (result == null) {
      return;
    }

    const {name, folderId, entityLinkField, tagSchemaId, studyIds} = result;
    const sequence = this;

    const translationLinkToCreate = entityLinkField
      ? {
          containerSequenceId: sequence.id,
          tagSchemaFieldId: entityLinkField.id,
        }
      : null;

    function success(proteinId: string): JQueryPromise<unknown> {
      if (entityLinkField) {
        notifications.success('AA sequence created successfully and linked to DNA sequence.');
        // Return a promise in order to update the tags, and to defer `always` callback from hiding the
        // loading screen
        return SequenceDAO.get(sequence.id).done(({tags}) => {
          AppDispatcher.dispatch({
            actionType: EventConstants.FILE_TAGS_UPDATED,
            tagData: [{id: sequence.id, tags}],
          });
        });
      } else {
        return FileBrowserActions.openFile(proteinId);
      }
    }

    let createTranslationPromise: Promise<void>;
    LoadingScreen.show();
    if (sequence.allowFeatureEdits() && !fromTranslation) {
      // Can only create translation if we have write access
      // When creating from a translation, there is no need to make a new translation
      // (which would not work anyway since sequence.selection is not guaranteed to match)
      createTranslationPromise = sequence.createTranslationIfNew(strand);
    } else {
      // No new translation was created
      createTranslationPromise = Promise.resolve();
    }

    createTranslationPromise
      .then(() => {
        AaSequenceActions.create({
          name,
          aminoAcids,
          folder: folderId,
          translationLink: translationLinkToCreate,
          tagSchemaId,
          success,
          studyIds,
          always(): void {
            LoadingScreen.hide();
          },
        });
      })
      .catch(() => {
        LoadingScreen.hide();
      });
  }

  getFragments(enzymeIds: Array<number>): Collection<BioJSSequence> {
    // eslint-disable-next-line no-restricted-syntax
    enzymeIds = _.uniq(enzymeIds);
    const enzymes = _(enzymeIds).map((id) => this.get('enzymes').get(id).toJSON());
    const _sequence = this.get('_sequence');
    const seqlen = _sequence.length();
    const circular = _sequence.get('circular');

    const fragments = new Backbone.Collection(biojsUtil.digest([_sequence], enzymes));
    fragments.each((fragment) => {
      fragment.set({selected: false});
      fragment.collection = fragments;
    });
    for (const model of Array.from(fragments.models)) {
      const startIndex = model.get('_startIndex');
      const offset3 = model.get('offset3');
      const offset5 = model.get('offset5');
      const blength = model.bases().length;

      const start = startIndex! + (offset5 < 0 ? -offset5 : 0);
      const end = startIndex! + blength - (offset3 > 0 ? offset3 : 0);
      const fraglen = circular ? ((end - start - 1 + seqlen) % seqlen) + 1 : end - start;

      model.set({
        start: circular ? (start + seqlen) % seqlen : start,
        end: circular ? (end + seqlen) % seqlen : end,
        length: fraglen,
      });
    }
    return fragments;
  }

  /**
   * @param {Object} options - An object containing data about the sequence to be created (partial list):
   *                           bases: A string of bases to replace the existing bases with.
   *                           name: A string of the new sequence's name.
   */
  createFromSelection(start: number, end: number, options: CreateFromSelectionOptions): BioJSSequence {
    _.defaults(options, {
      annotations: true,
      notcontained: true,
      tags: true,
      reverseComplement: false,
      padStart: '',
      padEnd: '',
      primers: [],
      primerBases: true,
      preserveIndices: false,
      bases: undefined,
      name: undefined,
      type: this.type(),
    });
    return this.get('_sequence').createFromIndices(start, end, {
      ...options,
      parentVersionId: this.getActiveVersionId(),
    });
  }

  canInsertPart(): boolean {
    return true;
  }

  _doSeqOp(op: SeqOperation, options: SeqOpOptions, callback?: () => void): DoSeqOpReturnPromise {
    // Save old selection so that we can restore it if the save fails.
    const selection = this.selection();
    const selStart = selection.start();
    const selEnd = selection.end();

    const xhr = this.get('_sequence').save(op, options);
    const renderPromise = xhr.client;

    // If the client had optimistically rendered, but then the save failed, we need to refetch the sequence.
    renderPromise.done(() => {
      xhr.fail((e: Response) => {
        if (e.status === 401) {
          this.get('_sequence').set({unrecoverable: true});
          notifications.notifyError(e);
          return;
        }
        LoadingScreen.show('Edit failed, reverting...');
        this.fetch()
          .fail((err) => {
            notifications.notifyError(err, {
              duration: 0,
              closeable: false,
              extra: 'Try refreshing to resume editing the sequence.',
            });
          })
          .done(() => {
            // The fetched sequence could be a completely different version from the old sequence,
            // if e.g. someone else had changed it, or the save did in fact go through but for some
            // reason didn't get back to the client. We should make sure the selection fits in the
            // sequence to prevent downstream warnings.
            let clampedSelEnd;
            let clampedSelStart;
            // @ts-expect-error: possibly comparing against null.
            if (selStart > this.length() || selEnd > this.length()) {
              clampedSelStart = 0;
              clampedSelEnd = null;
            } else {
              clampedSelStart = selStart;
              clampedSelEnd = selEnd;
            }

            selection.setEndpoints(clampedSelStart, clampedSelEnd);
            this.trigger('jump', clampedSelStart, clampedSelStart);
            LoadingScreen.hide();
          });
      });
    });

    if (!options.respondDiff) {
      LoadingScreen.show();
      xhr.always(() => {
        LoadingScreen.hide();
      });
    }

    // Not sure why TS doesn't know that xhr still has client attached, but it does.
    return xhr.done(() => {
      this.updateVersions({callback});
    }) as SaveXHR<unknown>;
  }

  reindex(current: number, desired: number, options: {callback?: () => void} = {}): DoSeqOpReturnPromise {
    const xhr = this._doSeqOp(
      {reindex: {current, desired}},
      {patch: true, respondDiff: true, fileUpdate: true},
      options.callback
    );
    xhr.client.done(() => {
      this.get('selection').reset(desired);
      this.trigger('jump', desired);
    });
    return xhr;
  }

  createPartAndReplace(
    start: number,
    end: number,
    newSequence: BioJSSequence,
    tagSchemaFieldId: Optional<number>
  ): DoSeqOpReturnPromise {
    const op = {
      create_part_and_replace: {start, end, new_sequence: newSequence, tag_schema_field_id: tagSchemaFieldId},
    };
    return this._doSeqOp(op, {patch: true, fileUpdate: true}).done((seq) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.FILE_TAGS_UPDATED,
        tagData: [{id: seq.id, tags: seq.tags}],
      });
      // Not sure why TS doesn't know that xhr still has client attached, but it does.
    }) as DoSeqOpReturnPromise;
  }

  insertPart(
    position: number,
    sequenceResult: SequenceSearchResult,
    options: {reverse?: boolean; complement?: boolean; callback?: () => void} = {}
  ): DoSeqOpReturnPromise {
    const reverse = options.reverse || false;
    const complement = options.complement || false;
    return this._doSeqOp(
      {insert_part: {pos: position, part: sequenceResult.get('id'), reverse, complement}},
      {patch: true, fileUpdate: true},
      options.callback
    );
  }

  replaceWithPart(
    start: number,
    end: number,
    sequenceId: string,
    options: {callback?: () => void; reverse?: boolean; complement?: boolean} = {}
  ): DoSeqOpReturnPromise {
    const reverseComplemented = Boolean(options.reverse) && Boolean(options.complement);
    return this._doSeqOp(
      {replace_with_part: {start, end, sequenceId, reverseComplemented}},
      {patch: true, fileUpdate: true},
      options.callback
    );
  }

  editPart(
    part: Part,
    options: {reverse?: boolean; complement?: boolean; callback?: () => void} = {}
  ): DoSeqOpReturnPromise {
    const edited = pick(options, 'reverse', 'complement');
    return this._doSeqOp(
      {
        // eslint-disable-next-line no-restricted-syntax
        edit_part: _.extend(edited, {part: part.get('id')}),
      },
      {patch: true, fileUpdate: true},
      options.callback
    );
  }

  deleteBases(
    start: number,
    end: number,
    options: {respondDiff?: boolean; fileUpdate?: boolean; patch?: boolean; callback?: () => void} = {}
  ): DoSeqOpReturnPromise {
    return this._doSeqOp(
      {del: {start, end}},
      {patch: true, respondDiff: true, fileUpdate: true},
      options.callback
    );
  }

  deletePart(part: Part, options: {callback?: () => void} = {}): DoSeqOpReturnPromise {
    return this._doSeqOp(
      {delete_part: {part: part.get('id')}},
      {patch: true, fileUpdate: true, respondDiff: true},
      options.callback
    );
  }

  unlinkPart(part: Part): DoSeqOpReturnPromise {
    return this._doSeqOp({unlink_part: {part: part.get('id')}}, {patch: true, fileUpdate: true});
  }

  insert(
    position: number,
    bases: string,
    options: {
      callback?: () => void;
      parts?: Array<PartAttributes>;
      annotations?: Array<AnnotationAttributes>;
      translations?: Array<TranslationAttributes>;
      translationGroups?: Array<TranslationGroup>;
      sequencePrimers?: Array<SequencePrimerAttributes>;
      modifiedNucleotides?: ModifiedNucleotides;
    } = {}
  ): DoSeqOpReturnPromise {
    const parts = options.parts ?? [];
    const annotations = options.annotations ?? [];
    const translations = options.translations ?? [];
    const translationGroups = options.translationGroups ?? [];
    const sequencePrimers = options.sequencePrimers ?? [];
    const modifiedNucleotides = options.modifiedNucleotides ?? [];
    return this._doSeqOp(
      {
        insert: {
          pos: position,
          bases,
          parts,
          annotations,
          translations,
          translationGroups,
          sequencePrimers,
          modifiedNucleotides,
        },
      },
      {patch: true, respondDiff: true, fileUpdate: true, bases},
      options.callback
    );
  }

  replace(
    start: number,
    end: number,
    bases: string,
    options: {
      callback?: () => void;
      parts?: Array<PartAttributes>;
      annotations?: Array<AnnotationAttributes>;
      translations?: Array<TranslationAttributes>;
      translationGroups?: Array<TranslationGroup>;
      sequencePrimers?: Array<SequencePrimerAttributes>;
      modifiedNucleotides?: ModifiedNucleotides;
      reverse?: boolean;
      complement?: boolean;
    } = {}
  ): DoSeqOpReturnPromise {
    const parts = options.parts ?? [];
    const annotations = options.annotations ?? [];
    const translations = options.translations ?? [];
    const translationGroups = options.translationGroups ?? [];
    const sequencePrimers = options.sequencePrimers ?? [];
    const modifiedNucleotides = options.modifiedNucleotides ?? [];
    const reverseComplemented = Boolean(options.reverse) && Boolean(options.complement);
    return this._doSeqOp(
      {
        replace_region: {
          start,
          end,
          bases,
          parts,
          annotations,
          translations,
          translationGroups,
          sequencePrimers,
          modifiedNucleotides,
          reverseComplemented,
        },
      },
      {patch: true, respondDiff: true, fileUpdate: true, bases},
      options.callback
    );
  }

  toggleCase(
    start: number,
    end: number,
    casing: Casing,
    options: {callback?: () => void} = {}
  ): DoSeqOpReturnPromise {
    return this._doSeqOp(
      {toggle_case: {start, end, casing}},
      {patch: true, respondDiff: true, fileUpdate: true},
      options.callback
    );
  }

  exactReplaceBases(
    start: number,
    end: number,
    newBases: string,
    options: {callback?: () => void} = {}
  ): DoSeqOpReturnPromise {
    return this._doSeqOp(
      {exact_replace_bases: {start, end, newBases}},
      {patch: true, respondDiff: true, fileUpdate: true},
      options.callback
    );
  }

  setSugarMod(position: number, sugarMonomerId: string): DoSeqOpReturnPromise {
    return this._doSeqOp({set_sugar_mod: {position, sugarMonomerId}}, {patch: true, fileUpdate: true}, () => {
      getStore().dispatch(editNucleotideIndices(this.get('id'), [position]));
    });
  }

  setBaseMod(position: number, baseMonomerId: string): DoSeqOpReturnPromise {
    return this._doSeqOp({set_base_mod: {position, baseMonomerId}}, {patch: true, fileUpdate: true}, () => {
      getStore().dispatch(editNucleotideIndices(this.get('id'), [position]));
    });
  }

  setPhosphateMod(position: number, phosphateMonomerId: string | null): DoSeqOpReturnPromise {
    return this._doSeqOp(
      {set_phosphate_mod: {position, phosphateMonomerId}},
      {patch: true, fileUpdate: true},
      () => {
        getStore().dispatch(editNucleotideIndices(this.get('id'), [position]));
      }
    );
  }

  bulkSetMods({rules}: BulkSetModsParams): DoSeqOpReturnPromise {
    return this._doSeqOp({bulk_set_mods: {rules}}, {patch: true, fileUpdate: true}, () => {
      if (rules[0].target.hasOwnProperty('positions')) {
        getStore().dispatch(
          editNucleotideIndices(this.get('id'), (rules[0] as PositionalRule).target.positions)
        );
      }
    });
  }

  finalize(options: {
    callback?: () => void;
    folder: unknown;
    fragmentResultStickyEnds: {[fragmentId: number]: {start: string; end: string}};
  }): DoSeqOpReturnPromise {
    // todo remove; server ignores folder
    const params = pick(options, 'folder', 'fragmentResultStickyEnds');
    return this._doSeqOp({finalize: params}, {patch: true, fileUpdate: true}, options.callback);
  }

  updateDynamicFeatures(): void {
    // Unfortunately, this happens after the bases change, so anybody listening
    // to change:bases could have out-of-date cutsites and ORFS.
    this.updateCuts();
    this.updateORFs();
  }

  updateORFs(): void {
    const orfMatches = this.isReallyBig()
      ? []
      : biojsUtil.orfs(
          this.get('_sequence').bases(),
          this.circular(),
          this.nucleotideType(),
          this.isSingleStranded(),
          preferences.get(SequenceMapPreferences.ORF_START_CODON)
        );
    const orfs = Array.from(orfMatches).map((values) => new ORF(values, {sequence: this}));
    // @ts-expect-error We add extra stuff into reset options; Backbone types are too strict
    this.get('orfs').reset(orfs, {sequence: this});
  }

  updateCutsInRange(range: {start: number; end: number}): void {
    // TODO: support circular

    // only if the sequence is large.
    if (!this.isReallyBig()) {
      return;
    }

    const newRange = {
      start: Math.max(0, range.start - 200),
      end: Math.min(this.length() - 1, range.end + 200),
    };

    if (newRange.start === this.oldRangeStart && newRange.end === this.oldRangeEnd) {
      return;
    }

    this.oldRangeStart = newRange.start;
    this.oldRangeEnd = newRange.end;

    this.get('enzymes').each((enzyme) => {
      const positions = this.get('_sequence').getCuts(enzyme.toJSON(), newRange);
      // @ts-expect-error We put lots of things into options; Backbone types are too strict
      return enzyme.set('cutPositions', positions, {trigger: false});
    });
    this.get('cutsites').trigger('cutsitesChanged');
  }

  updateCuts(): void {
    const reallyBig = this.isReallyBig();
    this.get('enzymes').each((enzyme) => {
      // If the sequence is small enough, compute the cutsites.
      if (!reallyBig) {
        // @ts-expect-error We put lots of things into options; Backbone types are too strict
        return enzyme.set('cutPositions', this.get('_sequence').getCuts(enzyme.toJSON()), {trigger: false});
      } else {
        // Otherwise, we will set them later.
        // @ts-expect-error We put lots of things into options; Backbone types are too strict
        return enzyme.set('cutPositions', [], {trigger: false});
      }
    });
    if (reallyBig) {
      this.trigger('cutswherepls');
    } else {
      this.get('cutsites').trigger('cutsitesChanged');
    }
  }

  createTranslation(strand: Strand): void {
    this.selection().trigger('translation-panel', strand);
  }

  async createTranslationIfNew(strand: StrandOfDoubleStranded): Promise<void> {
    const selection = this.selection().assertNotEmpty();
    const start = selection.start();
    const end = selection.end() % this.length();
    for (const translation of this._sequence().translations().models) {
      if (translation.start() === start && translation.end() === end && translation.strand() === strand) {
        return;
      }
    }
    const {translationGroup, translationRegions} = await SequenceDAO.createTranslationRegionGroup(this.id, {
      regions: [
        {
          modificationType: SequenceDAO.TranslationRegionModificationType.CREATE,
          start,
          end,
          strand,
        },
      ],
    });
    updateModelsAfterTranslationChange(this, [translationGroup], translationRegions, []);
  }

  _updateTranslationsByIds(translationIds: Array<number>, properties: Partial<TranslationAttributes>): void {
    const _sequence = this._sequence();
    for (const translationId of Array.from(translationIds)) {
      const translation = _sequence.translations().get(translationId);
      translation.set(properties);
    }
    this.updateVersions();
  }

  /**
   * Deletes the translation group with `groupId`.
   *
   * This makes a network request and return the `xhr` request object.
   */
  deleteTranslationGroup(groupId: number): JQueryPromise<void> {
    const _sequence = this._sequence();
    // todo move into SequenceDAO
    const xhr = net.delete_({
      url: `/1/api/sequences/${this.id}/translation-groups/${groupId}`,
    });
    xhr.done(() => {
      const translations = _sequence.translations().filter((t) => t.translationGroupId() === groupId);
      _sequence.translations().remove(translations);
      this.updateVersions();
    });
    return xhr;
  }

  async deleteFeature(feature: Annotation | Translation): Promise<void> {
    // Should only be used for annotations, translations
    await feature.destroy();
    await this.updateVersions();
  }

  lockingTab(): LockingTab {
    return this.get('lockingTabQueue')[0];
  }

  addLockingTab({tabId, tabName}: LockingTab): void {
    if (_.findWhere(this.get('lockingTabQueue'), {tabId})) {
      return;
    }
    assert(Boolean(tabName), 'Must provide tab name');
    this.set({lockingTabQueue: reactUpdate(this.get('lockingTabQueue'), {$push: [{tabId, tabName}]})});
    this.trigger('change:writable');
  }

  removeLockingTab(tabId: string): void {
    // eslint-disable-next-line no-restricted-syntax
    const i = _.findIndex(this.get('lockingTabQueue'), (tab) => tab.tabId === tabId);
    if (i === -1) {
      return;
    }
    this.set({lockingTabQueue: reactUpdate(this.get('lockingTabQueue'), {$splice: [[i, 1]]})});
    this.trigger('change:writable');
  }

  selectPrimerPair(pairId: number): Sequence {
    const pair = this.primerPairs().get(pairId);
    const [fwd, rev] = Array.from(pair.getPrimers(this.sequencePrimers()));
    const selection = this.selection();
    // @ts-expect-error: Fixme (Typescript 4.8 upgrade)
    fwd.click(this);
    // @ts-expect-error: Fixme (Typescript 4.8 upgrade)
    selection.selectPair(fwd, rev);
    return selection.trigger('showLinks');
  }

  selectFragment(fragment: FragmentResultModel): Sequence {
    let enzyme: Enzyme;
    let existing: Cutsite;
    const selection = this.get('selection');
    const start = fragment.get('start');
    const end = fragment.get('end');

    selection.reset(start);

    function unselect(sel: Selection): void {
      fragment.set({selected: false});
      sel.clearHandlers();
    }

    selection.setEndpoints(start, end);

    const cutter5 = fragment.get('_cutter5');
    if (cutter5 != null) {
      enzyme = this.get('enzymes').get(cutter5.id);
      enzyme.set({active: true});
      existing = this.get('cutsites').find((cutsite) => {
        if (cutsite.get('enzyme') === enzyme) {
          return cutsite.position() === start || cutsite.doubleCutterStart() === start;
        }
        return false;
      });
      if (existing != null) {
        // FIXME: it might not exist for big sequences, since we do not compute all cutsites in advance.
        // todo select is on selectables which cutsite extends from
        existing.select({multi: false});
        selection.addStartState({cutsite: existing});
      }
    }

    const cutter3 = fragment.get('_cutter3');
    if (cutter3 != null) {
      enzyme = this.get('enzymes').get(cutter3.id);
      enzyme.set({active: true});
      existing = this.get('cutsites').find((cutsite) => {
        if (cutsite.get('enzyme') === enzyme) {
          return cutsite.position() === end || cutsite.doubleCutterStart() === end;
        }
        return false;
      });
      if (existing != null) {
        // FIXME: Same dealio as above.
        // the ordering here is important for the restriction assembly wizard
        selection.addEndState({cutsite: existing});
        existing.select({multi: true});
      }
    }

    fragment.set({selected: true});
    selection.addHandlers({
      reset: unselect,
      linearExtend: unselect,
      setEndpoints: unselect,
    });
    return this.trigger('jump', start, fragment.cid);
  }

  changeHighlightCompatible(fileState: FileState, highlight: boolean): void {
    let enzyme;
    const enzymes = this.get('enzymes');
    if (highlight) {
      for (enzyme of Array.from(enzymes.filter((e) => e.active()))) {
        this.setEnzymeColors(enzyme, enzyme.color());
      }
    } else {
      for (enzyme of Array.from(enzymes.models)) {
        if (!enzyme.get('active')) {
          enzyme.set({color: null});
        }
      }
    }
  }

  setEnzymeColors(enzyme: Enzyme, newColor: string | null): void {
    if (this.get('fileState').get('toolbar').get('restrictionPanelState').get('highlightCompatible')) {
      let eid;
      let otherEnzyme;
      const enzymes = this.get('enzymes');
      // if one of the enzymes is still active don't unset all of them
      if (newColor == null) {
        let active = null;
        for (eid of Array.from(EnzymeUtil.getCompatibleEnzymeIds(enzyme.id))) {
          otherEnzyme = enzymes.get(eid);
          if (otherEnzyme.get('active')) {
            active = otherEnzyme;
            break;
          }
        }
        if (active != null) {
          enzyme.set({color: active.color()});
          return;
        }
      }
      for (eid of Array.from(EnzymeUtil.getCompatibleEnzymeIds(enzyme.id))) {
        otherEnzyme = enzymes.get(eid);
        otherEnzyme.set({color: newColor});
      }
    }
  }

  handleDoubleClick(regionStart: number, regionEnd: number): void {
    if (this.selectionContainedInPart()) {
      const parts = this.getSequencePartsAt(this.selection().start());
      if (parts.length === 1) {
        const part = parts[0];
        const start = part.start();
        const end = part.end() === 0 ? this.length() : part.end();
        this.selection().setEndpoints(start, end);
        return;
      }
    }
    // Default behavior is to select the whole "region" (e.g. slice)
    this.selection().reset(regionStart);
    this.selection().setEndpoints(regionStart, regionEnd);
  }

  isOligo = (): boolean => this.type() === SequenceType.OLIGO;

  isLongDNASequence(): boolean {
    return this.type() === SequenceType.DOUBLE_STRANDED;
  }

  isRNASequence = (): boolean => this.type() === SequenceType.SINGLE_STRANDED;

  isSingleStranded(): boolean {
    return this.type() === SequenceType.SINGLE_STRANDED || this.type() === SequenceType.OLIGO;
  }

  supportsTranslations(): boolean {
    return !this.isOligo();
  }

  supportsPrimers(): boolean {
    return !this.isOligo();
  }

  supportsParts(): boolean {
    return !this.isOligo();
  }

  supportsCRISPR(): boolean {
    return this.isLongDNASequence();
  }

  supportsChemicalMods = (): boolean =>
    BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES && (this.isOligo() || this.isRNASequence());

  isLatest(): boolean {
    return this.get('currentVersion');
  }
}

export {Sequence as ComponentsSequence, Version as SequenceVersion};

export {Tag, Tags, Selection, Sequence, Versions};
